import React, { useRef } from "react";
import { useInView } from "react-intersection-observer";
import styled from "styled-components";

const FadeAnimationWrapper = styled.div`
    ${(props) => props.dontAnimate ? 
        ``:
        `
        ${props.animateChildren ? `
            > *{
                opacity: ${props.inView ? 1 : 0};
                transition-duration: ${props.duration};
                transition-timing-function: ${props.timingFunction};
                transition-delay: ${props.delay};
                 transform: translateY(${props.inView ? "0" : props.animationDirection === "TopToBottom" ? "100px" : "-100px"});

                transition-property: all;
            }
            ` : 
            `
            opacity: ${props.inView ? 1 : 0};
            transition-duration: ${props.duration};
            transition-timing-function: ${props.timingFunction};
            transition-delay: ${props.delay};
             transform: translateY(${props.inView ? "0" : props.animationDirection === "TopToBottom" ? "100px" : "-100px"});
            transition-property: all;
            `}
        
        `
     }
`;

const FadeAnimation = ({children,duration="0.15s", timingFunction="ease", delay="0s", thresholdIntersection=0.1, showOnce=false, dontAnimate=true, animateChildren=false, animationDirection="TopToBottom"}) =>{

     const { ref, inView } = useInView({
            threshold: thresholdIntersection,
            triggerOnce: showOnce,
        });

    return(
        <FadeAnimationWrapper ref={ref} inView={inView} duration={duration} timingFunction={timingFunction} delay={delay} dontAnimate={dontAnimate} animateChildren={animateChildren} animationDirection={animationDirection}>
            {children}
        </FadeAnimationWrapper>
    )
}



export default FadeAnimation;